var _ = require('lodash');

var InputField = require('ub/ui/properties-panel/input-field');

var PhoneNumberActionField = function(options) {
  this.onActivate = options.onActivate;
  this.uiBinding = options.uiBinding;

  this.phoneNumberField = new InputField({
    label: 'Phone Number',
    placeholder: 'e.g: 6781234567',
    warningLabel: 'Note: call action only works on devices that can place a phone call',
    changeHandler: function(event) {
      this.uiBinding.onNext({
        type: 'changePhoneNumber',
        value: event.target.value
      });
    }.bind(this)
  });

  options.container.appendChild(this.phoneNumberField.inputContainer);

  this.setVisible(false);
};

PhoneNumberActionField.prototype = {
  setValue: function(newValue) {
    this.phoneNumberField.setValue(newValue || this.phoneNumberField.value || '');
  },

  setVisible: function(visible) {
    if (visible) {
      this.phoneNumberField.show();
    } else {
      this.phoneNumberField.hide();
    }
  },

  activate: function() {
    this.setVisible(true);

    if (_.isFunction(this.onActivate)) {
      this.onActivate(this);
    }
  },

  deactivate: function() {
    this.setVisible(false);
  }
};

module.exports = PhoneNumberActionField;



// WEBPACK FOOTER //
// ./src/ui/properties-panel/phone-number-action-field.js